/**
 * What: Renders blocked direct-route content for disabled or coming-soon Shopify capabilities.
 * Transport / data-flow: Pure React presentation over an already-resolved entitlement state.
 *
 */
import { CONNECTION_CHECK_ART } from './imagery/houseArt'
import { HouseEmptyState } from './imagery/HouseEmptyState'

type CapabilityUnavailablePageProps = {
  title: string
  message: string
}

/** Keeps gated direct routes from fetching data or showing functional controls. */
export function CapabilityUnavailablePage({ title, message }: CapabilityUnavailablePageProps) {
  return (
    <s-section>
      <HouseEmptyState heading={title} image={CONNECTION_CHECK_ART}>
        <p>{message}</p>
      </HouseEmptyState>
    </s-section>
  )
}
